import type { ComponentNameAndModule } from '@sitecore-jss/sitecore-jss-angular';
import {
  DynamicPricesGuard,
  GoToDynamicPricesGuard,
} from '@innogy/tariffs/store';

const loadChildren = async () => {
  return import('./lib/tariffs-lazy.module').then(
    (mod) => mod.TariffsLazyModule
  );
};

export const tariffsInMijnLazyImports: ComponentNameAndModule[] = [
  {
    path: 'DynamicPrices',
    loadChildren,
    canActivate: [DynamicPricesGuard],
  },
  {
    path: 'GoToDynamicPrices',
    loadChildren,
    canActivate: [GoToDynamicPricesGuard],
  },
];

export const tariffsInOpenLazyImports: ComponentNameAndModule[] = [
  {
    path: 'DynamicPrices',
    loadChildren,
  },
  {
    path: 'GoToDynamicPrices',
    loadChildren,
  },
];
